import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

// events manager id
const EVENTS_MANAGER_ID = 'ptfl6';
const SIGN_UP_EVENT_ID = 'tw-ptfl6-r63jh';
const KYC_COMPLETION_EVENT_ID = 'tw-ptfl6-r63jn';
const FIRST_DEPOSIT_EVENT_ID = 'tw-ptfl6-r6mqb';
const APP_DOWNLOAD_BUTTON_CLICKED_EVENT_ID = 'tw-ptfl6-r63jw';

@Injectable({
    providedIn: 'root'
})
export class TwitterPixelService {
    isStaging = false;

    constructor() {
        this.isStaging = environment.staging;
    }

    // code provided by ads pixel twitter
    load(): void {
        if (this.isStaging) return;
        (function (e: any, t, n, s, u, a) {
            e.twq || (s = e.twq = function () {
                s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
            }, s.version = '1.1', s.queue = [], u = t.createElement(n), u.async = !0, u.src = 'https://static.ads-twitter.com/uwt.js',
                a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(u, a))
        })(window, document, 'script');
        (window as any).twq('config', EVENTS_MANAGER_ID);
    }

    signUp(): void {
        if (this.isStaging) return;
        (window as any).twq('event', SIGN_UP_EVENT_ID, {});
    }

    kycCompletion(): void {
        if (this.isStaging) return;
        (window as any).twq('event', KYC_COMPLETION_EVENT_ID, {});
    }

    firstDeposit(userId: string): void {
        if (this.isStaging) return;
        (window as any).twq('event', FIRST_DEPOSIT_EVENT_ID, {
            conversion_id: userId,
        });
    }

    appDownloadClicked(): void {
        if (this.isStaging) return;
        (window as any).twq('event', APP_DOWNLOAD_BUTTON_CLICKED_EVENT_ID, {});
    }
}
